import { cn } from '@commenda/utils';
import type { ComponentProps } from 'react';

// streamdown hands every element override a `node` (HAST) prop that must be stripped before it
// reaches the DOM. Each wrapper below mirrors the matching packages/kakashi Table primitive.

type TheadProps = ComponentProps<'thead'> & { node?: unknown };
export function MarkdownTableHeader({
  node: _node,
  className,
  ...rest
}: TheadProps) {
  return <thead className={cn('bg-bg-secondary', className)} {...rest} />;
}

type TbodyProps = ComponentProps<'tbody'> & { node?: unknown };
export function MarkdownTableBody({
  node: _node,
  className,
  ...rest
}: TbodyProps) {
  return (
    <tbody
      className={cn('divide-y divide-border-primary bg-bg-primary', className)}
      {...rest}
    />
  );
}

type TrProps = ComponentProps<'tr'> & { node?: unknown };
export function MarkdownTableRow({ node: _node, ...rest }: TrProps) {
  return <tr {...rest} />;
}

type ThProps = ComponentProps<'th'> & { node?: unknown };
export function MarkdownTableHead({
  node: _node,
  className,
  ...rest
}: ThProps) {
  return (
    <th
      className={cn(
        'whitespace-nowrap px-xl py-md text-left txt-extra-small-bold text-text-primary',
        className
      )}
      {...rest}
    />
  );
}

type TdProps = ComponentProps<'td'> & { node?: unknown };
export function MarkdownTableCell({
  node: _node,
  className,
  ...rest
}: TdProps) {
  return (
    <td
      className={cn(
        'whitespace-nowrap px-xl py-2.5 align-top txt-small-regular text-text-primary',
        className
      )}
      {...rest}
    />
  );
}
